import { Typography } from 'antd';
import React from 'react';
import styles from './Title.module.less';

type TitleProps = {
  Icon?: React.ComponentType;
  text: string;
};

const Title = (props: TitleProps) => {
  const { text } = props;
  return (
    <div className={styles.titleContainer}>
      <div>
        <Typography.Title level={1}>{text}</Typography.Title>
      </div>
    </div>
  );
};

export default Title;
